import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import Constants from 'style/constants';

type Props = {
  disabled?: boolean;
  sx?: SxProps<Theme>;
  color?: string;
  tooltipText?: string;
};

export const PassageBlockedIcon = ({ disabled, sx, color, tooltipText }: Readonly<Props>): React.JSX.Element => {
  const iconColor = disabled !== undefined && disabled ? Constants.Colors.inactive : (color ?? Constants.Colors.primary);

  return (
    <Tooltip title={tooltipText}>
      <SvgIcon sx={sx} viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={iconColor}
          d="M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3432 15 9 13.6569 9 12C9 10.3431 10.3432 9 12 9ZM10.1777 11.1777C10.0643 11.4287 10 11.7067 10 12C10 13.1046 10.8954 14 12 14C12.2931 14 12.5705 13.9346 12.8213 13.8213L10.1777 11.1777ZM12 10C11.5535 10 11.1424 10.1482 10.8096 10.3955L13.6035 13.1895C13.8508 12.8566 14 12.4465 14 12C14 10.8954 13.1046 10 12 10Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={iconColor}
          d="M17 3C17.55 3 18.0211 3.1959 18.4131 3.58789C18.8051 3.97989 19.0007 4.45067 19 5V19H20C20.2833 19 20.5209 19.0961 20.7129 19.2881C20.9049 19.4801 21.0007 19.7173 21 20C20.9993 20.2827 20.9032 20.5202 20.7119 20.7129C20.5206 20.9056 20.2833 21.0013 20 21H4C3.71667 21 3.47942 20.9039 3.28809 20.7119C3.09676 20.5199 3.00067 20.2827 3 20C2.99934 19.7173 3.09542 19.4801 3.28809 19.2881C3.48075 19.0961 3.71801 19 4 19H5V5C5 4.45 5.1959 3.97922 5.58789 3.58789C5.97989 3.19656 6.45067 3.00067 7 3H17ZM7 19H17V5H7V19Z"
        />
      </SvgIcon>
    </Tooltip>
  );
};
